import React from 'react';
import WeatherContainer from './components/WeatherContainer';

function App() {
  return (
    <div className="App">
      <WeatherContainer />
    </div>
  );
}

export default App;
